import { Api } from "services/api/api.service";
import type { BackendAxiosError } from "services/api/backendError";
import { resolveStaffProfilePanelErrorMessage } from "../domains/employment/profilePanel.error.logic";
import type { EditingTab, PersonalDetailsForm } from "../profilePanel.contract";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

interface SavePersonalProfileParams {
  companyId: number | null;
  workerId: number | null;
  editedPersonalDetails: PersonalDetailsForm;
  onWorkerUpdated?: () => void;
  reloadProfile: () => void;
  setEditingTab: (value: EditingTab) => void;
  closeModal: () => void;
  setIsSaving: (value: boolean) => void;
  setSaveError: (value: string) => void;
  translate: TranslateFn;
}

export const savePersonalProfile = (
  params: SavePersonalProfileParams,
): void => {
  if (params.companyId == null || params.workerId == null) return;

  params.setIsSaving(true);
  params.setSaveError("");

  void Api()
    .company.staff.updateWorkerProfile(params.companyId, params.workerId, {
      firstName: params.editedPersonalDetails.firstName,
      lastName: params.editedPersonalDetails.lastName,
      phoneNumber: params.editedPersonalDetails.phoneNumber,
      email: params.editedPersonalDetails.email,
      personalIdentityNumber:
        params.editedPersonalDetails.personalIdentityNumber,
    })
    .then(() => {
      params.setEditingTab(null);
      params.closeModal();
      params.reloadProfile();
      params.onWorkerUpdated?.();
    })
    .catch((error: BackendAxiosError) => {
      params.setSaveError(
        resolveStaffProfilePanelErrorMessage(error, params.translate),
      );
    })
    .finally(() => {
      params.setIsSaving(false);
    });
};
